import React, { useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import { ArticleSearchResultsFxn } from '../../article/actions'
import { Button, Col, Form, Input, Row, Tooltip } from 'antd'
import { DefaultTablePagination, DisplayDate } from '../../../components/_utils/appUtils'
import ReactHtmlParser from 'react-html-parser'
import { TableComp } from 'sz-react-utils-lite'

const ArticleComp = () => {
  const dispatch = useDispatch()
  let tableRef = useRef()
  const [searchTerm, setSearchTerm] = useState('')
  let [total, setTotal] = useState(0)

  const apiRequest = (params) => {
    return new Promise(async (resolve) => {
      if (searchTerm && searchTerm.trim().length >= 3) {
        params.query = searchTerm
        let resp = await dispatch(ArticleSearchResultsFxn(params))
        setTotal(resp.total)
        resolve(resp)
      } else {
        setTotal(0)
        resolve({})
      }
    })
  }
  const searchArticle = async () => {
    setTimeout(() => {
      tableRef.current.reload()
    }, 300)
  }
  const clearFxn = () => {
    setSearchTerm('')
    setTimeout(() => {
      tableRef.current.reload()
    }, 300)
  }
  const columns = [
    {
      key: 'actions',
      title: 'Article Id',
      width: 80,
      render: (val, record) => (
        <Tooltip title='Edit Details'>
          <a href={`/articleView/${record._id}`}>
            {record.articleNo}
          </a>
        </Tooltip>

      )
    },
    {
      title: 'Submitted Date',
      key: 'submittedDate',
      dataIndex: 'submittedDate',
      width: 100,
      render: (item) => {
        return item ? DisplayDate(item) : null
      }
    },

    {
      title: 'Article Title',
      dataIndex: 'manuScriptTitle',
      align: 'center',
      key: 'manuScriptTitle',
      render: (text, record, index) => {
        return (
          <>
            {ReactHtmlParser(record.manuScriptTitle)}
          </>
        )
      }
    },
    {
      title: 'Journal',
      dataIndex: 'journal',
      key: 'journal',
      align: 'center',
      searchTextName: 'journal'

    },

    {
      title: 'Country',
      key: 'country',
      dataIndex: 'country'
    },
    {
      title: 'Author',
      key: 'correspondingAuthor',
      dataIndex: 'correspondingAuthor'
    },
    {
      title: 'Email',
      key: 'correspondingAuthorsEmail',
      dataIndex: 'correspondingAuthorsEmail'
    },

    {
      title: 'Volume',
      key: 'volumeName',
      filterRegex: true,
      dataIndex: 'volumeName'
    },
    {
      title: 'Issues',
      key: 'issues',
      filterRegex: true,
      dataIndex: 'issues'
    },
    {
      title: 'Doi Number',
      dataIndex: 'doiNumber',
      key: 'doiNumber',
      align: 'center',
      searchTextName: 'doiNumber'

    },

    {
      title: 'Author',
      dataIndex: 'authors',
      key: 'authors',
      align: 'center',
      render: (authors) => (
        <>
          {Array.isArray(authors) && authors.length > 0 ? (
            authors.map((author, idx) => (
              <div key={idx} style={{ marginBottom: 8 }}>
                <div><strong>Name:</strong> {author.name || '-'}</div>
                <div><strong>Designation:</strong> {author.designation || '-'}</div>
                <div><strong>Email:</strong> {author.email || '-'}</div>
              </div>
            ))
          ) : (
            <div>-</div>
          )}
        </>
      )
    }
  ]

  return (
    <div>
      <Form hideRequiredMark className={'inputForm'} style={{ marginBottom: '30px' }}>
        <Row gutter={16}>
          <Col span={6}>
            <Input className={'antInputSearch'}
                   placeholder={'Search your Author Email, name and article title'}
                   style={{ marginRight: '10px' }}
                   value={searchTerm}
                   onChange={(e) => setSearchTerm(e.target.value)}
            />
          </Col>
          <Col span={12}>
            <Button key='1' type='primary'
                    onClick={searchArticle}
                    style={{ marginRight: '10px' }}>
              Search
            </Button>
            <Button key='2'
                    type='primary'
                    onClick={clearFxn}>
              Clear
            </Button>
          </Col>
          <Col span={6}>
            <div className={'align-right'}>
              Total - {total}
            </div>
          </Col>
        </Row>
      </Form>

      <TableComp
        ref={tableRef}
        columns={columns}
        apiRequest={apiRequest}
        pagination={DefaultTablePagination({}, 10)}
      />

    </div>
  )
}
export default ArticleComp
